<div class="overview-grid">
    <div class="overview-grid-columns">
        <div class="overview-grid-left">
            <nb-accordion>
                <nb-accordion-item [expanded]="true">
                    <nb-accordion-item-header>Order Main</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-info class="order-info" [orderId]="orderId"></ubs-order-info>
                    </nb-accordion-item-body>
                </nb-accordion-item>
                <nb-accordion-item>
                    <nb-accordion-item-header>Order Contacts</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-contacts class="order-contacts" [orderId]="orderId"></ubs-order-contacts>
                    </nb-accordion-item-body>
                </nb-accordion-item>
                <nb-accordion-item>
                    <nb-accordion-item-header>Roles</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-roles class="order-roles" [orderId]="orderId"></ubs-order-roles>
                    </nb-accordion-item-body>
                </nb-accordion-item>
                <nb-accordion-item>
                    <nb-accordion-item-header>Communications</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-communications class="order-communications" [orderId]="orderId"></ubs-order-communications>
                    </nb-accordion-item-body>
                </nb-accordion-item> 
                <nb-accordion-item>
                    <nb-accordion-item-header>Notes</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-notes class="order-notes" [orderId]="orderId"></ubs-order-notes>    
                    </nb-accordion-item-body>
                </nb-accordion-item>  
            </nb-accordion>
        </div>
        <div class="overview-grid-right">
            <nb-accordion>
                <nb-accordion-item [expanded]="true">
                    <nb-accordion-item-header>Order Payments</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ubs-order-payments class="order-payments" [orderId]="orderId"></ubs-order-payments>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
        </div>
    </div>
    <div class="overview-grid-row">
        <nb-accordion>
            <nb-accordion-item>
                <nb-accordion-item-header>Shipping Info</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <ubs-order-shipping class="order-shipping" [orderId]="orderId"></ubs-order-shipping>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
        <nb-accordion>
            <nb-accordion-item [expanded]="true">
                <nb-accordion-item-header>Order Items</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <ubs-order-items class="order-items" [orderId]="orderId"></ubs-order-items>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
        
        
        
    </div>
</div>


<!-- Order Notes -->
<!-- Order Conversations -->
